import React, { Fragment } from "react";
import LoadingSpinner from "@components/indicators/LoadingSpinner/LoadingSpinner";
import ProgressBar from "@components/indicators/ProgressBar/ProgressBar";
import styles from "./LoadSaveErrorDisplay.module.css";

type LoadSaveErrorDisplayProps = {
    isLoading: boolean,
    isSaving?: boolean,
    progress?: number,
    showVideoMessage?: boolean,
    error: string | null,
};

const LoadSaveErrorDisplay: React.FC<LoadSaveErrorDisplayProps> = ({
    isLoading,
    isSaving = false,
    progress,
    showVideoMessage = false,
    error,
}) => {
    if (isLoading) {
        return (
            <div className={styles.loadingContainer}>
                <LoadingSpinner />
            </div>
        );
    }

    if (isSaving) {
        return (
            <div className={styles.loadingContainer}>
                {progress !== undefined ? (
                    <div className={styles.progressBarContainer}>
                        <ProgressBar progress={progress} />
                    </div>
                ) : (
                    <LoadingSpinner />
                )}
                <div className={styles.message}>Saving... Please wait...</div>
                {showVideoMessage && (
                    <div className={styles.secondaryMessage}>
                        <p>Video files may take a few minutes to process.</p>
                        <p>Do not leave this page until complete.</p>
                    </div>
                )}
            </div>
        );
    }

    if (error) {
        return <div className={styles.message}>{error}</div>;
    }

    return <Fragment />;
};

export default LoadSaveErrorDisplay;
